import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import orderBy from 'lodash/orderBy';
import { injectIntl, intlShape } from 'react-intl';
import AssignCourseUPF from '../../components/assign-course-upf';
import classEnum from '../class-roll/constants';
import * as actionTypes from './action-types';
import { DEFAULT_COUNTRY_ID, DEFAULT_COURSE_ID, DEFAULT_YEAR_GROUP } from '../../constants';
import { GET_NEW_COURSES_REQUEST } from '../class-roll/actions';
import { newCoursesAvailable } from '../../helpers/utils';
import messages from './messages';
import { showToast } from '../../components/toast/actions';
import { RESET_TOASTER_STATE } from '../manage-assigned-courses/action-types';

class AssignCoursesUPF extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: '',
            filteredCourses: [],
            selectedYearGroupId: DEFAULT_YEAR_GROUP,
            selectedCountryId: DEFAULT_COUNTRY_ID,
            yearGroups: [],
            initialLoad: true,
            legacy: this.props.selectedCourse.legacy,
            NewCourse: this.props.selectedCourse.NewCourse,
            UPF: this.props.selectedCourse.UPF,
            countryLoading: false
        };

        this.countries = [];
        this.selectedCourse = { id: DEFAULT_COURSE_ID, name: '' };
        this.selectedCountryId = DEFAULT_COUNTRY_ID;
    }

    componentDidMount() {
        if ((!this.props.countries || !this.props.countries.length) && !this.countries.length && !this.state.coursesLoading) {
            const { selectedProduct, dispatch } = this.props;
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({ countryLoading: true }, () => {
                dispatch({ type: actionTypes.GET_COUNTRY_REQUEST, selectedProductId: selectedProduct.id });
                dispatch({ type: actionTypes.GET_UPF_COUNTRY_REQUEST, selectedProductId: selectedProduct.id });
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { yearGroups, upfCountries, courses, deselectCourse, isNewCoursesSelected, newCourses } = nextProps;
        let currentCourses = courses;
        if (isNewCoursesSelected) {
            currentCourses = newCourses;
        }

        this.countries = upfCountries;

        this.selectedCourse = nextProps.selectedCourse;

        if (this.props.courses !== courses || this.props.newCourses !== newCourses) {
            if (this.selectedCountryId === classEnum.SCHOOL_COURSES) {
                this.updateCourseSelection(currentCourses);
            } else {
                this.updateCourseSelection(orderBy(currentCourses, ['isDefault'], ['desc']));
            }
        }

        if (deselectCourse) {
            this.clearSelectedCourse(yearGroups);
        } else {
            this.setState({ yearGroups });
        }
        if (nextProps.selectedCourse.legacy !== undefined &&
            (nextProps.selectedCourse.legacy !== this.state.legacy ||
            nextProps.selectedCourse.UPF !== this.state.UPF ||
            nextProps.selectedCourse.NewCourse !== this.state.NewCourse
            )) {
            this.setState({
                legacy: nextProps.selectedCourse.legacy,
                UPF: nextProps.selectedCourse.UPF,
                NewCourse: nextProps.selectedCourse.NewCourse
            }, () => this.handleOnYearGroupChange('', this.state.selectedYearGroupId));
        }
        if (nextProps.showAssignSuccessToast) {
            this.props.dispatch(showToast(this.props.intl.formatMessage(messages.assignCourseSuccess), 'success'));
            this.props.dispatch({ type: RESET_TOASTER_STATE });
        }

        if (nextProps.showAssignErrorToast) {
            this.props.dispatch(showToast(this.props.intl.formatMessage(messages.assignCourseFailure), 'error'));
            this.props.dispatch({ type: RESET_TOASTER_STATE });
        }
    }

    clearSelectedCourse = (yearGroups) => {
        const { dispatch } = this.props;
        const filteredCourses = this.state.filteredCourses.map(course => ({
            ...course,
            isSelected: false
        }));
        this.setState({ filteredCourses, yearGroups });
        dispatch({ type: actionTypes.DESELECT_COURSE, deselectCourse: false });
    }

    handleOnCountryChange = (name, selectedCountryId) => {
        const { dispatch } = this.props;
        this.selectedCountryId = selectedCountryId;

        this.setState({
            selectedCountryId,
            selectedYearGroupId: DEFAULT_YEAR_GROUP,
            filteredCourses: [],
            searchQuery: ''
        });

        if (selectedCountryId !== DEFAULT_COUNTRY_ID && selectedCountryId !== classEnum.SCHOOL_COURSES) {
            dispatch(
                {
                    type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST,
                    countryCode: selectedCountryId,
                    countryCourses: []
                }
            );
        }

        if (selectedCountryId === classEnum.SCHOOL_COURSES) {
            dispatch({ type: actionTypes.GET_YEAR_GROUP_REQUEST });
        }

        dispatch({ type: actionTypes.CLEAR_COURSE_LIST, productCourses: [] });
        this.selectedCourse = { id: DEFAULT_COURSE_ID, name: '' };
    }

    handleOnYearGroupChange = (name, selectedYearGroupId) => {
        const { selectedProduct, dispatch } = this.props;

        this.setState({ selectedYearGroupId, initialLoad: false, searchQuery: '' });

        if (this.selectedCountryId === classEnum.SCHOOL_COURSES) {
            if (selectedYearGroupId !== DEFAULT_YEAR_GROUP) {
                dispatch({ type: actionTypes.GET_SCHOOL_COURSE_REQUEST, yearGroup: selectedYearGroupId });
            } else {
                this.updateCourseSelection();
            }
        } else if (selectedYearGroupId !== DEFAULT_YEAR_GROUP) {
            if (this.props.isNewCoursesSelected && newCoursesAvailable(selectedYearGroupId)) {
                dispatch({
                    type: GET_NEW_COURSES_REQUEST,
                    countryCode: this.selectedCountryId,
                    productId: selectedProduct.id,
                    yearGroup: selectedYearGroupId,
                    isProductCoursesFetching: true
                });
            } else {
                dispatch({
                    type: actionTypes.GET_FILTERED_UPF_COURSES_REQUEST,
                    countryCode: this.selectedCountryId,
                    productId: selectedProduct.id,
                    yearGroup: selectedYearGroupId,
                    isProductCoursesLoaded: false,
                    isProductCoursesFetching: true,
                    selectGenericCourses: !this.props.selectedCourse.legacy,
                    includeGlobalCourses: true
                });
            }
        } else {
            this.updateCourseSelection();
        }

        this.selectedCourse = { id: DEFAULT_COURSE_ID, name: '' };
        this.props.handleOnCourseSelection(this.selectedCourse, true);

        if (this.state.selectedCountryId === DEFAULT_COUNTRY_ID) {
            this.setState({ initialLoad: true });
        }
    }

    handleOnSearchCourse = (e) => {
        const { courses } = this.props;
        const currentCourses = courses;
        let courseFilter = [];

        if (this.selectedCountryId === classEnum.SCHOOL_COURSES) {
            courseFilter = currentCourses;
        } else {
            courseFilter = orderBy(currentCourses, ['isDefault'], ['desc']);
        }
        const filteredCourses = courseFilter.filter(course =>
            course.name.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1);

        if (!filteredCourses.length) {
            this.selectedCourse = { id: DEFAULT_COURSE_ID, name: '' };
            this.props.handleOnCourseSelection(this.selectedCourse, true);
        }

        this.setState({ searchQuery: e.target.value });

        this.updateCourseSelection(filteredCourses);
    }

    handleOnCourseSelection = (course) => {
        this.selectedCourse = course;
        this.updateCourseSelection(this.state.filteredCourses);
        this.props.handleOnCourseSelection(course);
    }

    assignToYearGroup = () => {
        this.props.handleOnYearGroupSave(this.selectedCourse);
    }

    handleOptOutOfCourse = () => {
        this.selectedCourse = { id: DEFAULT_COURSE_ID, name: '' };
        this.props.handleOnCourseSelection(this.selectedCourse);
        this.props.handleOnYearGroupSave(this.selectedCourse);
        this.clearSelectedCourse(this.state.yearGroups);
    }

    updateCourseSelection = (courses = []) => {
        const filteredCourses = courses.map((course) => {
            let isSelected = false;
            if (this.selectedCourse && (course.name.toLowerCase() === this.selectedCourse.name.toLowerCase())) {
                isSelected = true;
            }
            return {
                ...course,
                isSelected
            };
        });
        this.setState({ filteredCourses });
    }

    disableYearGroup = () => this.selectedCountryId === DEFAULT_COUNTRY_ID

    disableSearchCourse = () => {
        const { selectedYearGroupId } = this.state;
        return this.selectedCountryId === DEFAULT_COUNTRY_ID || selectedYearGroupId === DEFAULT_YEAR_GROUP;
    }

    render() {
        const {
            filteredCourses,
            initialLoad,
            searchQuery,
            selectedYearGroupId,
            yearGroups
        } = this.state;

        return (
            <AssignCourseUPF
                disableAssignToYear={this.state.selectedYearGroupId === DEFAULT_YEAR_GROUP || this.state.selectedCountryId === DEFAULT_COUNTRY_ID || this.selectedCourse.id === DEFAULT_COURSE_ID}
                disableSearch={this.disableSearchCourse()}
                disableYearGroup={this.disableYearGroup()}
                filteredCourses={filteredCourses}
                forLegacy={this.state.legacy}
                handleOnCountryChange={this.handleOnCountryChange}
                handleOnSearchCourse={this.handleOnSearchCourse}
                handleOnYearGroupChange={this.handleOnYearGroupChange}
                initialLoad={initialLoad}
                searchQuery={searchQuery}
                selectedYearGroupId={selectedYearGroupId}
                yearGroups={yearGroups}
                {...this.props}
                assignToYearGroup={this.assignToYearGroup}
                countries={this.props.upfCountries}
                handleOnCourseSelection={this.handleOnCourseSelection}
                handleOptOutOfCourse={this.handleOptOutOfCourse}
                selectedCountryId={this.selectedCountryId} />
        );
    }
}

AssignCoursesUPF.propTypes = {
    intl: intlShape.isRequired,
    selectedProduct: PropTypes.object,
    countries: PropTypes.array,
    upfCountries: PropTypes.array,
    courses: PropTypes.array,
    yearGroups: PropTypes.array,
    selectedCourse: PropTypes.object,
    isProductCoursesLoaded: PropTypes.bool,
    isSchoolCoursesLoaded: PropTypes.bool,
    isNewCoursesLoaded: PropTypes.bool,
    deselectCourse: PropTypes.bool,
    handleOnCourseSelection: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    handleOnYearGroupSave: PropTypes.func,
    forYear: PropTypes.bool,
    isNewCoursesSelected: PropTypes.bool,
    newCourses: PropTypes.array,
    showAssignSuccessToast: PropTypes.bool,
    showAssignErrorToast: PropTypes.bool,
    showToast: PropTypes.func
};

function mapStateToProps(state = {}) {
    return {
        ...state,
        yearGroups: state.assignUPFCourses.yearGroups,
        countries: state.assignUPFCourses.countries,
        upfCountries: state.assignUPFCourses.upfCountries,
        courses: state.assignUPFCourses.filteredCourses,
        newCourses: state.classRoll.newCourses,
        isNewCoursesLoaded: state.classRoll.isProductCoursesLoaded,
        deselectCourse: state.assignUPFCourses.deselectCourse,
        isLoadingCountryYearGroups: state.assignUPFCourses.isLoadingCountryYearGroups,
        isProductCoursesLoaded: state.assignUPFCourses.isProductCoursesLoaded,
        isSchoolCoursesLoaded: state.assignUPFCourses.isSchoolCoursesLoaded,
        isCourseModalVisible: state.defaultCourses.isCourseModalVisible,
        courseDetails: state.defaultCourses.courseDetails,
        fetchingCourse: state.defaultCourses.fetchingCourse,
        selectedProduct: state.product,
        showAssignSuccessToast: state.assignCourseAdmin.showAssignSuccessToast,
        showAssignErrorToast: state.assignCourseAdmin.showAssignErrorToast
    };
}

export default injectIntl(connect(mapStateToProps)(AssignCoursesUPF));



// WEBPACK FOOTER //
// ./app/containers/assign-courses-upf/index.js